document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('bundle-builder')) return;

  // Block F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  document.addEventListener('keydown', (e) => {
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) ||
      (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) ||
      (e.ctrlKey && (e.key === 'U' || e.key === 'u')) ||
      (e.metaKey && e.altKey && (e.key === 'I' || e.key === 'i')) ||
      (e.metaKey && e.altKey && (e.key === 'J' || e.key === 'j')) ||
      (e.metaKey && (e.key === 'U' || e.key === 'u'))
    ) {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  // Block right-click context menu
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });
});
